module.exports = __webpack_public_path__ + "static/img/phone_poster_default@2x.18b93856.png";